module["exports"] = [
  "####",
  "###",
  "##",
  "#"
];
